<template>
  <section id="contact" class="py-20 bg-light-gray">
    <div class="container mx-auto px-6 md:px-14 md:pt-14 md:pb-36">
      <div class="text-center mb-32 reveal">
        <div class="accent-line mx-auto w-24 mb-4" />
        <h2 class="text-3xl md:text-4xl font-display font-bold mb-4 text-dark-text">
          <span class="text-gradient bg-gradient-to-r from-primary to-secondary">
            {{ $t('contact-title') }}
          </span>
        </h2>
      </div>

      <!-- 联系信息 -->
      <div class="fade-in" style="transition-delay: 0.4s">
        <div class="bg-white rounded-2xl p-2 md:p-8 border border-primary/20 mb-8">
          <div class="flex items-baseline">
            <div class="mr-4 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary flex-shrink-0">
              <i class="fa fa-envelope text-xl" />
            </div>
            <div style="text-align: justify">
              <h3 class="text-2xl font-bold mb-6">{{ $t('contact-email') }}</h3>
              <div class="space-y-6">
                <div class="items-start">
                  <div v-for="(item, index) in emails" :key="index">
                    <p class="text-black mb-2">{{ item.name }}</p>
                    <p class="text-secondary mb-4">{{ item.value }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { get_contact_email } from '@/api/sysConfig'

export default {
  name: 'Job',
  data() {
    return {
      emails: []
    }
  },
  computed: {
  },
  created() {
    get_contact_email().then((d) => {
      this.emails.splice(0)
      const list = JSON.parse(d[0].c)
      for (const element of list) {
        this.emails.push({ name: element.name, value: element.value })
      }
    })
  }
}
</script>
